<template>
  <div class="card dash-widget">
    <div class="card-body">
      <span class="dash-widget-icon">
        <i :class="iconClass"></i>
      </span>
      <div class="dash-widget-info">
        <h3 class="text " :class="labelClass">
          {{ value }}
        </h3>
        <slot></slot>
        <span v-if="$slots.label"> 
          <slot name="label"></slot>
        </span>
        <span v-else> 
            {{ label }}
        </span>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusCard",
  props: {
    iconClass: {
      type: String,
      default: "",
    },
    labelClass: {
      type: String,
      default: "text-danger",  
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
  },
};
</script>
 


// WEBPACK FOOTER //
// src/views/ai/chat/overview/StatusCard.vue